import { modal } from '@mx/vix';
import { lx } from '@/analytic';
import { bids, cids } from '@/analytic/lx-constants';
import { deferIndependenceSignFail, downgradeStandardCashier } from './callbackNativeRouter';
import { env } from '@/common';

export function showErrorModal(errorModalParams: ErrorModalParamsType) {
  const buttonName = env.isIndependenceSign ? '完成' : '去支付';
  const titleText = errorModalParams?.title ?? '先用后付 开启失败';
  lx.mv(bids.showSignFailModal, { button_name: buttonName, title: titleText }, { cid: cids.index });
  if (env.hideHalfPage) {
    deferIndependenceSignFail(errorModalParams?.resultData);
  } else {
    modal.show({
      title: titleText,
      content: errorModalParams?.content ?? '非常抱歉，先用后付暂时无法开启',
      preventScroll: true,
      button: [
        {
          text: buttonName,
          onClick: () => {
            modal.hide();
            lx.mc(bids.clickSignFailModal, { button_name: buttonName, title: titleText }, { cid: cids.index });
            if (env.isIndependenceSign) {
              deferIndependenceSignFail();
            } else {
              downgradeStandardCashier();
            }
          },
        },
      ],
    });
  }
}
